import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import Button from "@/js/common/ui/Button";

interface Props {
  atrzId: string;
  atrzLineId: string;
  atrzLinkDocId: string;
  setModalOpen: Function;
  setCallTime: Function;
  onDone?: () => void;
}

const BgtAtrzRejectReason = ({ atrzId, atrzLineId, atrzLinkDocId, setModalOpen, setCallTime, onDone}: Props) => {
  const [rjctRsnCn, setRjctRsnCn] = React.useState("");
  const [rejecting, setRejecting] = React.useState(false);

  const validateBase = () => {
    if (Util.isEmpty(atrzId)) {
      AppContext.openAlert({ title: "알림", msg: "결재 정보(atrzId)가 없습니다.", icon: "warning" });
      return false;
    }
    if (Util.isEmpty(atrzLineId)) {
      AppContext.openAlert({ title: "알림", msg: "결재 정보(atrzLineId)가 없습니다.", icon: "warning" });
      return false;
    }
    if (Util.isEmpty(atrzLinkDocId)) {
      AppContext.openAlert({ title: "알림", msg: "대상이 선택되지 않았습니다.", icon: "warning" });
      return false;
    }
    return true;
  };

  const submitReject = () => {
    if (rejecting) return;
    if (!validateBase()) return;

    const rsn = String(rjctRsnCn ?? "").trim();
    if (Util.isEmpty(rsn)) {
      AppContext.openAlert({ title: "알림", msg: "반려 사유를 입력해주세요.", icon: "warning" });
      return;
    }

    setRejecting(true);
    AppContext.showSpinner();

    Axios.dataAccess({
      url: "system/atrz/process-aprvr-idnty-rjct.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        atrzId: String(atrzId),
        atrzLineId: String(atrzLineId),
        atrzLinkDocId: String(atrzLinkDocId),
        atrzLinkDocIdntySeCd: "02",
        rjctRsnCn: rsn,
      },
      onSuccessFn: () => {
        AppContext.hideSpinner();
        setRejecting(false);

        AppContext.openAlert({ title: "알림", msg: "반려 처리되었습니다.", icon: "info" });

        if (typeof setModalOpen === "function") setModalOpen(false);
        if (typeof setCallTime === "function") setCallTime(new Date());
        onDone?.();
      },
    });
  };

  return (
    <div className="pr20 pt10 pb10 w520">
      <div className="mb10">
        <textarea
          value={rjctRsnCn}
          onChange={(e) => setRjctRsnCn(e.target.value)}
          className="w100p bd1 bdcDDDDDD bdrd6 p10 fm-c fs13"
          style={{ height: 140, resize: "none", outline: "none" }}
          placeholder="반려 사유를 입력해주세요."
          disabled={rejecting}
        />
      </div>

      <div className="dpFlx jcC gap10">
        <Button
          width={100}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          variant="styCancelBtn"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          buttonName="취소"
          onClickFunc={() => setModalOpen(false)}
          disabled={rejecting}
        />

        <Button
          width={120}
          height={40}
          fontFamily="fm-b"
          fontSize={16}
          letterSpacing={-1}
          color="#fff"
          backgroundColor="crimson"
          borderRadius={6}
          buttonClass="dpFlx aiC jcC"
          buttonName={rejecting ? "처리중..." : "반려처리"}
          onClickFunc={submitReject}
          disabled={rejecting}
        />
      </div>
    </div>
  );
};

export default BgtAtrzRejectReason;
